import api from "./api";

class ProjectService {
    search(term, params = {}) {
        return api.get("/api/projects/", { params: { search: term, ...params } });
    }

    list(params = {}) {
        return api.get("/api/projects/", { params });
    }

    get(id) {
        return api.get(`/api/projects/${id}/`);
    }

    getContacts(id) {
        return api.get("/api/contacts/", { params: { project: id } });
    }

    getDrawingDocuments(id) {
        return api.get("/api/drawing-documents/", { params: { project: id } });
    }

    getDrawingSets(id) {
        return api.get("/api/drawing-sets/", { params: { project: id } });
    }

    getAttachments(id) {
        return api.get(`/api/projects/${id}/`);
    }
}

export default new ProjectService();
